<script setup lang="ts">
  import { useFriendsStore } from '~/store/friends';

  const emit = defineEmits<{
    close: [];
  }>();

  const { isMobile } = useDeviceType();

  function closeDialog() {
    emit('close');
  }

  function handleEscape(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      closeDialog();
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleEscape);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleEscape);
  });

  function init() {
    useFriendsStore().getUserFriends();
  }

  init();
</script>

<template>
  <UModal
    title="Manage friends modal"
    description="Here you can manage your friends"
    :ui="{ content: 'max-w-[1360px] w-full overflow-y-auto' }"
    :fullscreen="isMobile"
    :close="{ onClick: closeDialog }"
  >
    <template #content>
      <Icon
        class="size-8 fixed text-white top-2.5 right-2.5 cursor-pointer rotate-45"
        name="i-lucide:plus"
        @click="closeDialog"
      />
      <div class="h-full md:h-[590px] py-6 md:py-4 lg:py-12 px-6 flex flex-wrap gap-6 justify-center">
        <GameFriendsListAddFriendsCard />

        <GameFriendsListStatusesCard />

        <GameFriendsListRequestCard />
      </div>
    </template>
  </UModal>
</template>
